var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},_vm._l((_vm.elements),function(el){return _c('div',[_vm._v(_vm._s(el.title))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }